<kaz-default-frame>
  <div class="flex flex-col">
    <div class="flex flex-col md:hidden">
      <kaz-search></kaz-search>
      <!-- Divider -->
      <div class="my-4 border-t border-[#EFEFEF]"></div>
      <kaz-slide-menu></kaz-slide-menu>
      <!-- Divider -->
      <div class="mt-0 mb-3 border-t border-[#EFEFEF]"></div>
    </div>
    <!-- Zuletzt angesehen -->
    @if (lastSeen.length > 0 && hasValidatedAd()) {
      <div class="flex flex-col gap-2 md:bg-[#FAFAFA] md:p-4 md:mb-7 md:rounded-[2px]">
        <span class="font-semibold text-xl">Zuletzt angesehen</span>
        <div class="flex flex-row gap-2 pb-5 overflow-x-auto snap-x md:pb-0">
          @for (last of lastSeen; track last) {
            <div class="flex flex-row">
              @if (last.validated && !last.reserved) {
                <kaz-card-last-seen class="snap-center" [ad]="last"></kaz-card-last-seen>
              }
            </div>
          }
        </div>
      </div>
    }
    <!-- Divider -->
    @if (lastSeen.length > 0) {
      <div class="mt-0 mb-5 border-t border-[#EFEFEF] md:hidden"></div>
    }
    <!-- Für Sie empfohlen -->
    <span class="font-semibold text-xl mb-2 md:mb-4">Für Sie empfohlen</span>
    <div class="flex flex-col gap-2 md:grid md:grid-cols-4">
      @for (recommend of recommended; track recommend; let i = $index) {
        <div>
          <kaz-card-recommended [ad]="recommend"></kaz-card-recommended>
        </div>
        @if ((i + 1) % 7 === 0 || (recommended.length < 7 && i === recommended.length - 1)) {
          <div>
            <kaz-smart-entry [type]="SmartAdType.RECTANGLE" [class]="'w-full h-full'" class="w-full h-full block"></kaz-smart-entry>
          </div>
        }
      }
    </div>
    @if (recommended.length > 0 && nextToken !== '@end') {
      <kaz-button [isLoading]="loadingAds" (onClick)="loadMoreRecommends()" class="mt-4 md:w-[343px] md:self-center mb-12" buttonType="bordered" text="Mehr laden"></kaz-button>
    }
  </div>
</kaz-default-frame>
